import { HeaderComponent } from './header/header.component';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PipesModule } from './pipes/pipes.module';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ModalConfirmPinComponent } from './modal-confirm/modal-confirm-pin.component';
import { ModalGlobalConfirmComponent } from './global-confirm/global-confirm.component';
import { ModalPinChangeComponent } from './modal-pin-change/modal-pin-change.component';
import { DropdownPanelComponent } from './components/dropdown-panel/dropdown-panel.component';
import { SettingsButtonComponent } from './components/settings-button/settings-button.component';
import { SectionPanelComponent } from './components/section-panel/section-panel.component';
import { WelcomePanelComponent } from './welcome-panel/welcome-panel.component';
import { RangeColorpickerComponent } from './components/range-colorpicker/range-colorpicker.component';
import { PopupModalComponent } from './components/popup-modal/popup-modal.component';
import { TogglePanelComponent } from './components/toggle-panel/toggle-panel.component';
import { HintModalComponent } from './components/modals/hint-modal/hint-modal.component';
import { TimePickerComponent } from './components/time-picker/time-picker.component';
import { ValueSelectorComponent } from './components/value-selector/value-selector.component';
import { MinutesPickerComponent } from './components/minutes-picker/minutes-picker.component';
import { TemperaturePickerComponent } from './components/temperature-picker/temperature-picker.component';
import { SoundPickerComponent } from './components/sound-picker/sound-picker.component';
import { SanitizationConfirmModalComponent } from './components/modals/sanitization-confirm-modal/sanitization-confirm-modal.component';
import { InputFieldComponent } from './components/input-field/input-field.component';
import { AlertsWidgetComponent } from './dashboard-widgets/alerts-widget/alerts-widget.component';
import { AlertCardComponent } from './dashboard-widgets/alerts-widget/alert-card/alert-card.component';
import { SurveyWidgetComponent } from './dashboard-widgets/survey-widget/survey-widget.component';
import { ArmSliderComponent } from './dashboard-widgets/arm-slider/arm-slider.component';
import { LightControlComponent } from './dashboard-widgets/light-control/light-control.component';
import { LightSettingsComponent } from './dashboard-widgets/light-control/light-settings/light-settings.component';
import { ClimateControlComponent } from './dashboard-widgets/climate-control/climate-control.component';
import { ThermometerWidgetComponent } from './dashboard-widgets/climate-control/thermometer-widget/thermometer-widget.component';
import { AutoScheduleNudgeComponent } from './dashboard-widgets/climate-control/auto-schedule-nudge/auto-schedule-nudge.component';
import { ScenesWidgetComponent } from './dashboard-widgets/scenes-widget/scenes-widget.component';
import { MoodAudioBarComponent } from './dashboard-widgets/scenes-widget/mood-audio-bar/mood-audio-bar.component';
import { SubpageLayoutComponent } from './subpage-forms/subpage-layout/subpage-layout.component';
import { ContactSupportFormComponent } from './contact-support-form/contact-support-form.component';
import { DropdownListComponent } from './components/dropdown-list/dropdown-list.component';
import { UnavailableHintComponent } from './components/unavailable-hint/unavailable-hint.component';
import { CarouselComponent } from './components/carousel/carousel.component';
import { CarouselSlideDirective } from './directives/carousel-slide.directive';
import { ReleaseNotesModalComponent } from './components/modals/release-notes-modal/release-notes-modal.component';
import { IncomingCallNotificationComponent } from './components/incoming-call-notification/incoming-call-notification.component';
import { WaterLeakBannerComponent } from './components/water-leak-banner/water-leak-banner.component';
import { SevereWeatherBannerComponent } from './components/severe-weather-banner/severe-weather-banner.component';

import { UpdateModalComponent } from './components/modals/update-modal/update-modal.component';
import { HolidayPopupComponent } from './components/holiday-popup/holiday-popup.component';

@NgModule({
  declarations: [
    HeaderComponent,
    ModalConfirmPinComponent,
    ModalGlobalConfirmComponent,
    ModalPinChangeComponent,
    DropdownPanelComponent,
    SettingsButtonComponent,
    SectionPanelComponent,
    AlertsWidgetComponent,
    AlertCardComponent,
    SurveyWidgetComponent,
    WelcomePanelComponent,
    ArmSliderComponent,
    LightControlComponent,
    LightSettingsComponent,
    RangeColorpickerComponent,
    ClimateControlComponent,
    ThermometerWidgetComponent,
    AutoScheduleNudgeComponent,
    ScenesWidgetComponent,
    MoodAudioBarComponent,
    PopupModalComponent,
    TogglePanelComponent,
    HintModalComponent,
    TimePickerComponent,
    ValueSelectorComponent,
    MinutesPickerComponent,
    TemperaturePickerComponent,
    SoundPickerComponent,
    SanitizationConfirmModalComponent,
    InputFieldComponent,
    SubpageLayoutComponent,
    ContactSupportFormComponent,
    DropdownListComponent,
    UnavailableHintComponent,
    CarouselComponent,
    CarouselSlideDirective,
    ReleaseNotesModalComponent,
    IncomingCallNotificationComponent,
    WaterLeakBannerComponent,
    SevereWeatherBannerComponent,
    UpdateModalComponent,
    HolidayPopupComponent,
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    RouterModule,
    PipesModule,
    ScrollingModule,
  ],
  exports: [
    HeaderComponent,
    PipesModule,
    ScrollingModule,
    SectionPanelComponent,
    DropdownPanelComponent,
    SettingsButtonComponent,
    AlertsWidgetComponent,
    AlertCardComponent,
    SurveyWidgetComponent,
    WelcomePanelComponent,
    ArmSliderComponent,
    LightControlComponent,
    ClimateControlComponent,
    ScenesWidgetComponent,
    MoodAudioBarComponent,
    RangeColorpickerComponent,
    PopupModalComponent,
    TogglePanelComponent,
    HintModalComponent,
    SanitizationConfirmModalComponent,
    TimePickerComponent,
    ValueSelectorComponent,
    MinutesPickerComponent,
    TemperaturePickerComponent,
    SoundPickerComponent,
    InputFieldComponent,
    SubpageLayoutComponent,
    ContactSupportFormComponent,
    DropdownListComponent,
    UnavailableHintComponent,
    CarouselComponent,
    CarouselSlideDirective,
    ReleaseNotesModalComponent,
    IncomingCallNotificationComponent,
    WaterLeakBannerComponent,
    SevereWeatherBannerComponent,
    UpdateModalComponent,
    HolidayPopupComponent,
  ],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }

